
import { defineComponent, reactive, ref, computed } from 'vue';
import { message } from 'ant-design-vue';
import { formatWithIntl } from '@/utils/illuminate';
import { request } from '@/utils/request';
import { createApiUrl, firstError, isValidateError } from '@/utils/utils';
import type { TableColumn } from '@/components/Table';

export default defineComponent({
  name: 'AddressEditorModal',
  emits: ['complete'],
  setup(props, ctx) {
    const visible = ref(false);
    const submiting = ref(false);
    const record = ref({ invoiceRecordId: 0, invoiceNo: '', invoiceApplyType: 0 });
    const list = ref<{}[]>([]);

    const tableColumns: TableColumn[] = [
      { title: '订单编号', dataIndex: 'orderNo' },
      { title: '用户姓名', dataIndex: 'createUser', customRender: ({ text }) => text || '---' },
      { title: '用户手机号', dataIndex: 'phone' },
      { title: '订单金额', dataIndex: 'totalRealAmount', customRender: ({ text }) => `${formatWithIntl(text)} 元` },
    ];

    const loadList = async () => {
      const isEleServiceFee = record.value.invoiceApplyType === 5;
      let res: any;
      try {
        if (isEleServiceFee) {
          res = await request.post(createApiUrl('/newlinkSass/invoice/find-invoice-ele-orders'), {
            pageNo: 1,
            pageNum: 1,
            pageSize: 20,
            invoiceId: record.value.invoiceRecordId,
            invoiceNo: record.value.invoiceNo,
          });
        } else {
          res = await request.get(createApiUrl('/newlinkSass/invoice/find-order-by-invoice-no'), {
            params: { invoiceId: record.value.invoiceRecordId, invoiceNo: record.value.invoiceNo },
          });
        }
      } catch (e: Error & any) {
        return message.error(e.message);
      }

      list.value = isEleServiceFee ? (res.data?.list || []) : res.data;
    };

    const view = (item: any) => {
      visible.value = true;
      record.value = item;
      loadList();
    };

    const onCancel = () => {
      list.value = [];
    };

    return {
      visible,
      submiting,

      view,
      list,
      tableColumns,
      onCancel,
    };
  },
});
